<script setup lang="ts">
    import { useRouter, useRoute } from 'vue-router';
    import type { IssueShare } from '../../interfaces';
    import BsAlert from '@shared/components/BsAlert.vue';
    import { AlertTypes } from '@shared/components/BsAlerts';
    import List from '@shared/components/List/List.vue';

    const props = defineProps<{
        shares: IssueShare[];
        isAnonymousTracking: boolean;
    }>();

    const router = useRouter();
    const route = useRoute();

    const hasShares = () => props.shares.some((s) => s.ContactCount + s.ReadCount > 0);

    const orderOptions = [
        { display: $Resources.IssueStatisticsSharedLabel, key: 'ContactCount' },
        { display: $Resources.IssueStatisticsShareReadLabel, key: 'ReadCount' },
    ];

    function showShares(share: IssueShare) {
        if (props.isAnonymousTracking) return;
        router.push({
            name: 'IssueStatisticsContacts',
            params: { issueId: route.params.issueId, contactType: 'Shared' },
            query: { ...route.query, channel: share.Channel },
        });
    }
</script>

<template>
    <div class="print-block">
        <h2 class="h3 m-0-b">
            {{ $Resources.IssueStatisticsSharesHeading }}
            <button
                type="button"
                class="popover-trigger popover-trigger-lg"
                v-popover-info="{ heading: $Resources.IssueStatisticsSharesHeading, body: $Resources.IssueStatisticsSharesIntroduction }">
                <span class="glyphicon glyphicon-info-sign" aria-hidden="true"></span>
            </button>
        </h2>

        <BsAlert class="m-sm-t" :show="!hasShares()" :type="AlertTypes.Info" :dismissible="false" :content="$Resources.IssueStatisticsNoSharesMessages" />

        <List
            v-if="hasShares()"
            class="th2-text-right th3-text-right"
            display-as="table"
            itemId="Channel"
            :items="shares"
            :filter-keys="['Channel']"
            :orderOptions="orderOptions"
            :table-headers="[$Resources.IssueStatisticsSharesHeading, $Resources.IssueStatisticsSharedLabel, $Resources.IssueStatisticsShareReadLabel]">
            <template #item="{ item }">
                <td>{{ item.Channel }}</td>
                <td class="text-right strong">
                    <a href="javascript:void(0)" @click="showShares(item)">{{ item.ContactCount }}</a>
                </td>
                <td class="text-right strong">{{ item.ReadCount }}</td>
            </template>
        </List>
    </div>
</template>
